export default class Lob {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/lob";
  }

  lobValueList() {
    return this.client.get(`${this.resourceUrl}/config/referenceValues`);
  }
}
